// src/pages/Home.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      {/* HERO */}
      <section className="relative w-full min-h-[80vh] flex items-center justify-center">
        <video
          src="/assets/hero-wraps.mp4"
          poster="/assets/hero-wraps-fallback.jpg"
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />

        <a
          href="https://instagram.com/ulwraps"
          target="_blank"
          rel="noreferrer"
          className="absolute right-6 bottom-6 opacity-90 hover:opacity-100 transition"
          aria-label="Instagram @ULWraps"
        >
          <img
            src="/assets/instagramicon.png"
            alt="Instagram Icon"
            className="w-14 h-14 object-contain drop-shadow-lg hover:scale-105 transition-transform"
          />
        </a>

        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-white">
            Wrap It Tight. Keep It Safe.
          </h1>
          <p className="text-lg sm:text-2xl text-white/90 mt-2">
            Dry & Wet install PPF for cars that actually get driven.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/colors"
              className="px-6 py-3 bg-white text-black rounded-xl font-semibold hover:bg-neutral-200 transition"
            >
              Browse Colors
            </Link>
            <Link
              to="/gallery"
              className="px-5 py-3 border border-white/60 text-white rounded-xl text-sm font-medium hover:bg-white hover:text-black transition"
            >
              Gallery
            </Link>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16">
  <h2 className="text-3xl sm:text-4xl font-bold text-center text-white">
    Built to Protect. Designed to Flex.
  </h2>
  <p className="mt-3 text-sm sm:text-base text-neutral-400 text-center max-w-2xl mx-auto">
    From full color changes to stealth PPF and of course the OG clear PPF, every roll to insure OEM paint quality finish.
  </p>

  {/* TWO cards, centered */}
  <div className="mt-10 grid gap-6 md:grid-cols-2 max-w-4xl mx-auto">
    <ServiceCard
      title="Top Selling Colored PPF"
      text="Our most requested colored protection films, ready to ship."
      tag="Browse All Colors"
      tagHref="/colors/top-sellers"
      colors={[
        { label: "Gloss Super Black", href: "/colors/gloss-super-black" },
        { label: "Super Matte Black", href: "/colors/matte-black" },
        { label: "Gloss Nardo Grey", href: "/colors/gloss-nardo-grey" },
        { label: "Gloss Brooklyn Grey", href: "/colors/gloss-brooklyn-grey" },
      ]}
    />

    <ServiceCard
      title="Top Selling Clear PPF"
      text="Self-healing clear films for people who actually drive their cars."
      tag="Browse All Clear PPF"
      tagHref="/colors/clear-ppf"
      colors={[
        { label: "Ultra Gloss Clear", href: "/colors/ultra-gloss-clear" },
        { label: "Stealth Matte Clear", href: "/colors/stealth-matte-clear" },
      ]}
    />
  </div>
</section>
    </>
  );
}


function ServiceCard({ title, text, tag, tagHref, colors = [] }) {
  return (
    <div className="rounded-2xl border border-neutral-800 bg-neutral-950/80 p-6 flex flex-col justify-between">
      <div>
        <h3 className="text-lg font-semibold text-white">{title}</h3>

        {/* Optional description text */}
        {text && (
          <p className="mt-2 text-sm text-neutral-400">
            {text}
          </p>
        )}

        {/* Bullet list of colors */}
        {colors.length > 0 && (
          <ul className="mt-3 space-y-1 text-sm text-neutral-300 list-disc list-inside">
            {colors.map((color) => (
              <li key={color.href || color.label}>
                <Link
                  to={color.href}
                  className="hover:text-emerald-400 hover:underline underline-offset-2"
                >
                  {color.label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Green tag link at bottom */}
      {tag && (
        tagHref ? (
          <Link
            to={tagHref}
            className="mt-4 text-[11px] uppercase tracking-wide text-emerald-400 hover:text-emerald-300"
          >
            {tag}
          </Link>
        ) : (
          <span className="mt-4 text-[11px] uppercase tracking-wide text-emerald-400">
            {tag}
          </span>
        )
      )}
    </div>
  );
}
